export var ProgressCssClass;
(function (ProgressCssClass) {
    ProgressCssClass["Base"] = "iress-progress";
    ProgressCssClass["ActiveBackground"] = "iress-progress__indicator";
    ProgressCssClass["InactiveBackground"] = "iress-progress__wrapper";
})(ProgressCssClass || (ProgressCssClass = {}));
//# sourceMappingURL=progress.types.js.map